import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { LESSON_PLANNER_MODE } from 'types';
import { remCalc } from 'util/style-util';
import { translate } from 'translations/translator';
const getTranslation = key => translate('lessonPlanner', key);

export const NoInstruction = ({
  maybeDraggableProps,
  mode = LESSON_PLANNER_MODE.LESSON_PLANNER,
  allowInstruction,
  ...props
}) => {
  const BASE_STYLES = {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  };
  const NO_INSTRUCTION_STYES = {
    ...BASE_STYLES,
    backgroundColor: '#D8D8D8',
    opacity: 0.6,
    marginTop: '-0.5px'
  };

  const { noInstruction } = useStyles();

  return (
    <Box
      {...props}
      style={!allowInstruction ? NO_INSTRUCTION_STYES : BASE_STYLES}
      {...maybeDraggableProps}
    >
      <Typography className={noInstruction} variant="caption">
        {mode === LESSON_PLANNER_MODE.LESSON_PLANNER
          ? allowInstruction
            ? getTranslation('noLessonsPlannedForToday')
            : getTranslation('nonTeachingDay')
          : getTranslation('noAssignmentsPlannedForToday')}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  noInstruction: { padding: remCalc(0, 10, 0, 10), fontSize: 14, color: '#454545' }
}));
